import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MenuItems } from '@core';

import { PageNotFoundComponent } from './error-pages/page-not-found/page-not-found.component';
import { WindowsNotSupportedComponent } from './error-pages/windows-not-supported/windows-not-supported.component';
import { ServerErrorComponent } from './error-pages/server-error/server-error.component';
import { SessionPendingComponent } from './error-pages/session-pending/session-pending.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: MenuItems.routePlanner.path,
        pathMatch: 'full'
    },
    {
        path: 'windows-not-supported',
        component: WindowsNotSupportedComponent
    },
    {
        path: 'server-error',
        component: ServerErrorComponent
    },
    {
        path: 'session-pending',
        component: SessionPendingComponent
    },
    { path: '**', component: PageNotFoundComponent }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {}
